import React from 'react';
import OnVisible, { setDefaultProps } from 'react-on-visible';

setDefaultProps({
    bounce: true,
    visibleClassName: 'appear',
    percent: 400,
});

const Section = ({ expertises, title, content, src, alt, inverseRow }) => {
    const Expertises = () => (
        <React.Fragment>
            <header>
                <h3>{title}</h3>
            </header>
            <p>{content}</p>
            <h4 className="title-roboto">Expertise</h4>
            {!!expertises && (
                <ul>
                    {expertises.map((value) => {
                        const { howwework_repeat_expertise: expertise } = value;
                        return <li key={expertise}>{expertise}</li>;
                    })}
                </ul>
            )}
        </React.Fragment>
    );

    const Animation = () => (
        <img className="about__illustration" src={src} alt={alt} />
    );

    return (
        <OnVisible>
            <section className="about__section">
                <div className="about__section--inner">
                    <div className="about--grid">
                        <div className="col-left">
                            <Expertises />
                        </div>

                        {src && (
                            <div className="col-right">
                                <Animation />
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </OnVisible>
    );
};

export default Section;



// WEBPACK FOOTER //
// ./src/components/Pages/About/Section.jsx